<template>
  <div
    class="col-span-2 mt-md grid grid-cols-3 gap-sm"
    v-if="insights.length > 0"
  >
    <InsightItem v-for="(insight, index) in insights" :key="index">
      {{ insight.beskrivning }}
    </InsightItem>
  </div>
</template>

<script setup lang="ts">
import { type Ref, onBeforeMount, ref } from "vue";

import type { Insikt } from "@/composables/KundserviceAppApiClient";
import { useApi } from "@/composables/useApi";

import InsightItem from "./InsightItem.vue";

export type InsightsProps = {
  individId: string;
};
const props = defineProps<InsightsProps>();
const apiClient = useApi();
const insights: Ref<Insikt[]> = ref([]);

async function getInsikter() {
  insights.value = await apiClient.getInsikterForAnstalld(props.individId);
}

onBeforeMount(() => {
  getInsikter();
});
</script>
